module.exports = __webpack_public_path__ + "static/media/luggage_dropoff.a88a57f8.svg";